
/**
 * Slick setup
 */
$(document).ready(function () {



    // ----------------------------------------------
    // Slides (http://kenwheeler.github.io/slick/)
    // ----------------------------------------------
    $('.slide-list').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: function (slider, i) {
            return '&nbsp;';
        },
        nextArrow: '<div class="slide-control next"></div>',
        prevArrow: '<div class="slide-control prev"></div>',
        slide: '.slide',
        arrows: true,
        dots: true,
        autoplay:true,
        autoplaySpeed:6000
        //variableWidth: true
    });



    // ----------------------------------------------
    // Carousel (http://kenwheeler.github.io/slick/)
    // ----------------------------------------------
    $('.gallery-carousel').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        customPaging: function (slider, i) {
            return '&nbsp;';
        },
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 300,
                settings: "unslick"
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
        arrows: false,
        dots: true
        //variableWidth: true
    });

});

